import React from "react";
import styled from "styled-components";
const constants = require("../constants");

const sizes = {
  xl: constants.fontSize.xl + "px",
  lg: constants.fontSize.lg + "px",
  md: constants.fontSize.md + "px",
  sm: constants.fontSize.sm + "px",
  xs: constants.fontSize.xs + "px",
};

const TextWrapper = styled.div`
  font-size: ${props => sizes[props.size]};
  color: ${props => props.color || constants.colors.text};
  font-weight: ${props => props.weight};
  display: ${props => props.display || "block"};

  ${props => props.css};
`;

export default function Text(props) {
  const {
    size = "md",
    color,
    weight = null,
    flex = false,
    display = "block",
    style,
    css = {},
    ...rest
  } = props;

  return (
    <TextWrapper
      size={size}
      color={color}
      weight={weight}
      display={display}
      style={style}
      css={css}
      {...rest}
    >
      {props.children}
    </TextWrapper>
  );
}
